import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, numberFormat, responsivefy} from "@/common/functions";

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;

    axios.post(url, filterParam).then(res => {
        let data = res.data;
        const max = d3.max(data, (d) => d.metric2);
        var number = data.length;

        const containerMargin = {
            top: chart.margin.top,
            right: chart.margin.right,
            bottom: chart.margin.bottom,
            left: chart.margin.left
        };
        const containerWidth = chart.width - containerMargin.left - containerMargin.right;
        const containerHeight = chart.height - containerMargin.top - containerMargin.bottom;

        const svg = d3.select(divId)
            .append("svg")
            .attr("width", containerWidth + containerMargin.left + containerMargin.right)
            .attr("height", containerHeight + containerMargin.top + containerMargin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + containerMargin.left + "," + containerMargin.top + ")");

        const speedometerWidth = containerWidth / number;

        function createGaugeChart(svg, value, n, index) {
            const radius = Math.min(speedometerWidth, containerHeight) / 2;
            const speedometerX = index * speedometerWidth + speedometerWidth / 2;

            const speedometerSvg = svg.append("g")
                .attr("width","2000")
                .attr("transform", "translate(" + speedometerX + "," + (containerHeight / 2) + ")");

            const background = speedometerSvg.append("path")
                .datum({ endAngle: Math.PI / 2 })
                .style("fill", "url(#backgroundGradient)")
                .attr("d", d3.arc()
                    .innerRadius(radius * 0.7)
                    .outerRadius(radius)
                    .startAngle(-Math.PI / 2)
                    .endAngle(Math.PI / 2)
                );
            console.log(background);

            const color = d3.scaleSequential(d3.interpolateBlues);

            const gradient = speedometerSvg.append("defs")
                .append("linearGradient")
                .attr("id", "backgroundGradient")
                .attr("x1", "0%")
                .attr("x2", "100%")
                .attr("gradientTransform", "rotate(0)")
                .selectAll("stop")
                .data([0, 1])
                .enter().append("stop")
                .attr("offset", (d, i) => `${i * 100}%`)
                .attr("stop-color", color);
            console.log(gradient);

            const foreground = speedometerSvg.append("path")
                .datum({ endAngle: 0 / 2 })
                .style("fill", "none")
                .attr("d", d3.arc()
                    .innerRadius(0)
                    .outerRadius(radius)
                    .startAngle(-Math.PI / 2)
                );

            var div = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;');

            const valueText = speedometerSvg.append("text")
                .attr("text-anchor", "middle")
                .attr("dy", radius - 50);

            const pointer = speedometerSvg.append("polygon")
                .attr("points", "0,5 -100,0 0,-5")
                .attr("fill", "red")
                .on("mousemove", function () {
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(chart.x1MetricTooltip + colonAnnotation + value
                        + '<br>' + chart.y1MetricTooltip + colonAnnotation + n)
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0);
                });

            const minValue = 0;
            const maxValue = max + 200000000;
            const tickCount = 6;

            const ticks = d3.ticks(minValue, maxValue, tickCount);
            const tickAngles = ticks.map(tick => (tick / maxValue) * 180 - 90);
            speedometerSvg.selectAll("line")
                .data(tickAngles.slice(1))
                .enter().append("line")
                .attr("y1", -radius)
                .attr("y2", -radius * 0.85)
                .attr("transform", d => "rotate(" + d + ")")
                .style("stroke", "black");

            speedometerSvg.selectAll("text")
                .data(ticks)
                .enter().append("text")
                .attr("text-anchor", "middle")
                .attr("dy", (d, i) => {
                    const angle = tickAngles[i];
                    return angle > 90 || angle < -90 ? radius * 1.1 : -radius * 1.1;
                })
                .attr("transform", (d, i) => "rotate(" + tickAngles[i] + ")")
                .text(d => numberFormat(d))
                .style("fill", chart.axisLabelFontColor)
                .style("font-size", chart.axisLabelFontSize);

            function arcTween(newValue) {
                return function (d) {
                    const interpolate = d3.interpolate(d.endAngle, newValue * Math.PI / 180 - Math.PI / 2);
                    return function (t) {
                        d.endAngle = interpolate(t);
                        return d3.arc()
                            .innerRadius(radius * 0.7)
                            .outerRadius(radius)
                            .startAngle(-Math.PI / 2)(d);
                    };
                };
            }

            function updateGauge(value) {
                const scale = d3.scaleLinear()
                    .domain([0, maxValue])
                    .range([0, 180]);

                foreground.transition()
                    .duration(1000)
                    .attrTween("d", arcTween(value * scale(1)));

                valueText.text(n + " " + chart.x1AxisDisplayName + " " + numberFormat(value))
                    .style("fill", chart.axisFontColor)
                    .style("font-size", chart.axisFontSize);

                pointer.transition()
                    .duration(1000)
                    .attr("transform", "rotate(" + scale(value) + ")");
            }

            updateGauge(value);
        }

        data.forEach((d, i) => {
            createGaugeChart(svg, d.metric2, d.metric1, i);
        });
    });
}
